<template>
  <div class="form">
    <div class="head">
      <p class="phase">{{ phase }}</p>
      <div class="progress-bar">
        <div class="progress" :style="{ width: (question_num / questions_total) * 100 + '%' }"></div>
      </div>
      <div class="progress-label" :style="{ width: (question_num / questions_total) * 100 + '%' }">
        <!-- <p>{{category_label}}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: ["phase", "questions_total", "question_num", "category_label"],
  data() {
    return {
      progress: 0
    };
  },
  firestore() {
    return {};
  },
  methods: {},
  watch: {
    question_num() {
      console.log(this.question_num / this.questions_total)
      this.$store.commit(
        "setApplicationApprovalProgress",
        (this.question_num / this.questions_total) * 100
      );
    }
  }
};
</script>

<style scoped lang="scss">
.form {
  margin-top: 15px;
  .head {
    text-align: center;
    width: 100%;
    margin: auto;
    max-width: 350px;
    position: relative;
    .phase {
      font-size: 15px;
      color: #0b6efb;
      margin: 0;
      margin-bottom: 8px;
    }
    .progress-bar {
      background: rgba(8, 91, 209, 0.1);
      border-radius: 10px;
      height: 7px;
      width: 90%;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      position: relative;
      overflow: hidden;
      .progress {
        background-color: #0b6efb;
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        transition: width 0.5s;
      }
    }

    .progress-label {
      position: absolute;
      left: 0;
      width: 100%;
      text-align: right;
      p {
        margin: 0;
        opacity: 0.5;
        font-size: 13px;
        margin-top: 3px;
        white-space: nowrap;
      }
    }
  }
}
</style>
